import { render, staticRenderFns } from "./noo.vue?vue&type=template&id=59ab2600&scoped=true&"
import script from "./noo.vue?vue&type=script&lang=js&"
export * from "./noo.vue?vue&type=script&lang=js&"
import style0 from "./noo.vue?vue&type=style&index=0&id=59ab2600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab2600",
  null
  
)

export default component.exports